export type UserType = 'parent' | 'child' | 'mentor' | 'self-managed' | 'organization' | 'support';

export const getUserTypeLabel = (type: UserType): string => {
  switch (type) {
    case 'parent':
      return 'Parent';
    case 'child':
      return 'Child';
    case 'mentor':
      return 'Mentor';
    case 'self-managed':
      return 'Self-managed';
    case 'organization':
      return 'Organization';
    case 'support':
      return 'Support';
    default:
      return 'Unknown';
  }
};

export const getUserTypeBadgeVariant = (type: UserType) => {
  // Return 'outline' for all types to show text only without background colors
  return 'outline' as const;
};